<template>
  <div class="order-type-wrap sm mb24" v-if="orderTypes?.length > 0">
    <div
      class="order-type-btn btn-1"
      v-for="(item, i) in orderTypes"
      @click="handleOrderTypeClick($event, item, i)"
      :class="[selectedOrderType == item.orderType ? 'active' : '']"
      :key="i"
    >
      <div class="fs-12 lh16 bold tc">{{ item.title }}</div>
      <div
        class="fs-10 lh16 normal color-grey"
        v-if="
          selectedOrderType == item.orderType &&
          item.orderType != 'D' &&
          displayDistanceOrTimeActive
        "
      >
        {{ displayDistanceOrTimeActive }} Km
      </div>
      <div
        class="fs-10 lh16 normal color-grey"
        v-else-if="selectedOrderType == item.orderType && item.orderType == 'D'"
      >
        --
      </div>
      <div
        class="fs-10 lh16 normal color-grey"
        v-else-if="selectedOrderType != item.orderType && item.orderType == 'D'"
      >
        Select Location
      </div>
      <div class="fs-10 lh16 normal color-grey" v-else>Select Store</div>
    </div>
  </div>
</template>

<script>
import { keyMapsAction, keyMapsMutation } from "../helpers/storeKeys";
import LocalStorageFunc from "../helpers/localStorageFunc";
import Utility from "../helpers/utility";
import { updateAmplitudeUserProperties } from "../helpers/analyticsEvents";
import { EVENT_CLICK_ORDERTYPE } from "../helpers/analyticsEvents";
import { OrderTypesCode } from "../helpers/orderTypesConstants";

export default {
  name: "OrderType",
  components: {
    //
  },
  props: ["dataResults"],
  data() {
    return {
      orderTypes: [],
      // isTakeAwaySelected: false,
    };
  },
  mounted() {
    this.$store.commit(keyMapsMutation.LOAD_CURRENT_ORDER_TYPE);
    if (!this.isOnLocationPage) {
      this.$store.commit(
        keyMapsMutation.UPDATE_SELECTED_ORDER_TYPE,
        this.currentOrderType
      );
    }
    this.orderTypes = Utility.tryJsonParse(this.dataResults, []);
  },
  methods: {
    handleOrderTypeClick(event, item, index) {
      // if (item.orderType === "D") {
      //   LocalStorageFunc.setDeliveryTypeStationData({});
      // }
      this.$store.commit(
        keyMapsMutation.UPDATE_SELECTED_ORDER_TYPE,
        item.orderType
      );
      this.$store.commit(
        keyMapsMutation.UPDATE_SHOW_MANUAL_LOCATION_SCREEN,
        false
      );

      // this.$store.dispatch(
      //   keyMapsAction.LOAD_RECENT_LOCATION_FROM_LOCAL_STORAGE
      // );

      EVENT_CLICK_ORDERTYPE({
        positionWithinSection: index + 1,
        category: item.title,
        orderType: item.orderType,
      });
      updateAmplitudeUserProperties({ orderType: item.orderType });

      Utility.sendToLocationScreen({ changeTriggerFromDineinTwy: false });
    },
  },
  computed: {
    selectedOrderType() {
      return this.isOnLocationPage
        ? LocalStorageFunc.getSelectedDeliveryType() ||
            this.$store.state.User.currentOrderType
        : this.$store.state.User.selectedOrderType ||
            this.$store.state.User.currentOrderType;
    },
    currentOrderType() {
      return this.$store.state.User.currentOrderType;
    },
    closeTakeAwayListingModal() {
      this.$store.commit(keyMapsMutation.UPDATE_IS_TAKEWAY_SELECTED, false);
    },
    deliveryTypeStationData() {
      return LocalStorageFunc.getDeliveryTypeStationData();
    },
    displayDistanceOrTimeActive() {
      return LocalStorageFunc.getDeliveryTypeStationData()?.driveDistanceInKm;
    },
    isOnLocationPage() {
      return Utility.isCurrentlyAtUrl("/location");
    },
  },
};
</script>
